export default {
  title: 'Maksuyhdyskäytävä',
  description:
    'Omat maksuyhdyskäytäväsi verkkotilauksille. Koko tilaussumma tilitetään yhdyskäytävätilillesi; tilität itse ravintoloillesi.',
  toasts: {
    load_error: 'Yhdyskäytäväasetusten lataaminen epäonnistui',
  },
  not_enabled: {
    title: 'Spreedly ei ole vielä käytössä tililläsi',
    description:
      'FoodAmigos aktivoi paikalliset maksuyhdyskäytävät. Ota yhteyttä FoodAmigos-yhteyshenkilöösi aloittaaksesi.',
  },
  processor_mode: {
    title: 'Kuka käsittelee maksut?',
    description:
      'Tämä asetetaan kerralla kaikille ravintoloillesi. Voit vaihtaa myöhemmin Kumppaniasetuksista, kunhan yksikään ravintola ei ole vielä käytössä.',
    save: 'Tallenna',
    options: {
      platform: {
        title: 'FoodAmigos käsittelee maksut',
        badge: 'Suositeltu',
        description:
          'Hoidamme maksutilin, vahvistuksen ja tilitykset. Jokainen ravintola lisää yritystietonsa ja suorittaa lyhyen tarkistuksen Adyenin kanssa.',
        methods: 'Hyväksytyt: {{methods}}',
      },
      provider: {
        title: 'Käytän omaa palveluntarjoajaa',
        description: 'Yhdistä jo käyttämäsi maksupalveluntarjoaja. Tilitykset, maksut ja vahvistus jäävät heille.',
      },
    },
    payment_methods: {
      card: 'Kortti',
      apple_pay: 'Apple Pay',
      google_pay: 'Google Pay',
      pay_by_bank: 'Maksu pankista',
      giropay: 'giropay',
      sepa_debit: 'SEPA',
    },
    locked: {
      platform: 'FoodAmigos käsittelee maksut kaikille ravintoloillesi.',
      provider: 'Ravintolasi vastaanottavat maksuja omien palveluntarjoajiesi kautta.',
    },
    confirm_choice: {
      title: 'Asetetaanko maksut tilaan “{{mode}}”?',
      description:
        'Tämä koskee kaikkia ylläpitämiäsi ravintoloita. Voit vaihtaa myöhemmin Kumppaniasetuksista, mutta vain kun yksikään ravintola ei ole käytössä.',
      confirm: 'Tallenna ja jatka',
    },
    switch: {
      link: 'Vaihda maksujen käsittelytapaa',
      confirm: {
        confirm: 'Vaihda',
        provider: {
          title: 'Vaihdetaanko omaan palveluntarjoajaan?',
          description: 'FoodAmigos-maksuja käyttävät ravintolat palaavat tilaan Ei käytössä.',
        },
        platform: {
          title: 'Vaihdetaanko FoodAmigos-maksuihin?',
          description: 'Omia palveluntarjoajia käyttävät ravintolat palaavat tilaan Ei käytössä.',
        },
      },
      unavailable: {
        title: 'FoodAmigos-maksut eivät ole vielä saatavilla',
        description: 'FoodAmigos-maksut eivät ole vielä saatavilla maassasi.',
        confirm: 'OK',
      },
      blocked: {
        title: 'Ota yhteyttä FoodAmigosiin tämän muuttamiseksi',
        description_one:
          '{{count}} ravintola ottaa vastaan live-maksuja. Vaihtaminen tarkoittaisi, että se liittyy uudelleen uuden palveluntarjoajan kanssa. Tiimimme suunnittelee sen kanssasi.',
        description_other:
          '{{count}} ravintolaa ottaa vastaan live-maksuja. Vaihtaminen tarkoittaisi, että ne liittyvät uudelleen uuden palveluntarjoajan kanssa. Tiimimme suunnittelee sen kanssasi.',
        confirm: 'Lähetä sähköpostia FoodAmigosille',
        subject_one: 'Vaihda maksujen käsittelytapaa ({{count}} live-ravintola)',
        subject_other: 'Vaihda maksujen käsittelytapaa ({{count}} live-ravintolaa)',
      },
    },
    toasts: {
      load_error: 'Maksuasetusten lataaminen epäonnistui',
      save_error: 'Maksuasetusten tallentaminen epäonnistui',
      chosen: 'Maksujen käsittely tallennettu',
      switched: 'Maksujen käsittely vaihdettu',
    },
  },
  gateways: {
    title: 'Yhdistetyt palveluntarjoajat',
    empty: 'Yhdistä jo käyttämäsi maksupalveluntarjoaja. Ravintolasi liitetään sen alle.',
    connect_another: 'Yhdistä palveluntarjoaja',
    support_hint:
      'Kun ravintola alkaa ottaa vastaan live-maksuja, sen palveluntarjoajan vaihto suunnitellaan kanssamme — kirjoita osoitteeseen {{email}}.',
    kinds: {
      stripe_connect: 'Stripe Connect',
      spreedly: 'Maksuyhdyskäytävä',
      platform_adyen: 'FoodAmigos-maksut',
    },
    statuses: {
      connected: 'Yhdistetty',
      disconnected: 'Yhteys katkaistu',
      needs_attention: 'Vaatii huomiota',
    },
    issue: {
      connect_not_enabled: {
        title: 'Stripe Connect ei ole käytössä tilillä {{name}} takana olevalla tilillä',
        description:
          'Stripe ei voi luoda tilejä ravintoloillesi ennen kuin Connect on käytössä. Ota se käyttöön Stripe-hallintapaneelissasi ja tarkista sitten uudelleen täältä.',
      },
      account_restricted: {
        title: 'Stripe pidättää uusien tilien luomisen tilillä {{name}}',
        description:
          'Stripe on tilapäisesti rajoittanut tiliäsi luomasta yhdistettyjä tilejä. Kirjaudu Stripe-hallintapaneeliisi, vahvista, että aioit luoda nämä tilit, ja tarkista sitten uudelleen täältä.',
      },
      loss_liability_unaccepted: {
        title: 'Stripe vaatii, että {{name}} hyväksyy tappiovastuun ensin',
        description:
          'Stripe-alustasi ei ole vielä hyväksynyt vastuuta ravintoloidesi tilien negatiivisista saldoista, joten Stripe ei luo niitä. Avaa Stripe-hallintapaneelissa Settings → Connect → Platform profile ja täytä tappiovastuun hyväksyntä, tarkista sitten uudelleen täältä. Voit jättää huomiotta Stripen alla olevan Accounts v2 -huomautuksen.',
      },
      account_creation_refused: {
        title: 'Stripe kieltäytyi luomasta ravintolatiliä kohteelle {{name}}',
        description: 'Tarkista alla oleva viesti Stripe-hallintapaneelissasi ja tarkista sitten uudelleen täältä.',
      },
      key_invalid: {
        title: 'Stripe ei enää hyväksy avainta, jonka yhdistit kohteelle {{name}}',
        description:
          'Avain on vaihdettu, kumottu tai vanhentunut. Luo uusi avain Stripe-hallintapaneelissasi ja korvaa se täällä.',
      },
      key_access_limited: {
        title: 'Stripe on rajoittanut avainta, jonka yhdistit kohteelle {{name}}',
        description:
          'Rajoitettu avain ei voi luoda tilityksiä tai maksuja ravintoloillesi. Avaa Stripe-hallintapaneelissa Developers → API keys ja palauta avaimen täydet oikeudet, tarkista sitten uudelleen täältä — tai vaihda avain ja korvaa se täällä.',
      },
      provider_said: 'Stripen viesti: “{{message}}”',
      hint: 'Kunnes tämä on ratkaistu, tähän palveluntarjoajaan liitetyt ravintolat eivät voi aloittaa verkkomaksujen vastaanottamista.',
      open_stripe: 'Avaa Stripe-hallintapaneeli',
      check_again: 'Tarkista uudelleen',
      replace_key: 'Vaihda avain',
      cleared: 'Stripe hyväksyi ravintolasi jälleen',
      still_blocked: 'Stripe kieltäytyy yhä — katso yllä oleva vastaus',
    },
    refused: {
      provider_said: 'Mitä {{name}} sanoi: ”{{message}}”',
      reference: 'Viite:',
      contact_support: 'Lähetä sähköpostia tukeen',
      support_subject: 'Maksupalveluntarjoajan yhdistäminen hylättiin: {{name}} (viite {{reference}})',
      account_in_test_mode: {
        action: 'Poista testitila käytöstä Authorize.Netissä kohdassa {{path}} ja yritä sitten uudelleen.',
        open: 'Avaa Authorize.Net',
      },
      processor_not_configured: {
        action:
          'Soita kauppiaspalveluntarjoajallesi, yritykselle joka avasi Authorize.Net-tilisi, ja pyydä heitä viimeistelemään sen asetukset maksunvälittäjän kanssa. Uudet avaimet eivät muuta tätä. Yritä sitten uudelleen.',
        action_card_connect:
          'Pyydä CardConnectin tukea ottamaan käyttöön verkkokauppavaltuutukset (card-not-present) tälle kauppiastunnukselle. Uudet API-tunnukset eivät muuta tätä. Yritä sitten uudelleen.',
      },
    },
    table: {
      primary_tag: 'Oletus',
      live_count_one: '{{count}} vastaanottaa maksuja',
      live_count_other: '{{count}} vastaanottaa maksuja',
      attention_count_one: '{{count}} vaatii huomiota',
      attention_count_other: '{{count}} vaatii huomiota',
      columns: {
        connection: 'Palveluntarjoaja',
        status: 'Tila',
        restaurants: 'Ravintolat',
        methods: 'Paikalliset maksutavat',
      },
      methods_count: '{{enabled}}/{{capable}} käytössä',
    },
    picker: {
      recommended: 'Suositeltu',
      connect: 'Yhdistä',
      stripe_connect: {
        title: 'Stripe Connect',
        description:
          'Käytä omaa Stripe-tiliäsi. Jokainen ravintola suorittaa Stripen oman käyttöönoton; tilitykset ja maksut hoituvat Stripen kautta.',
        already_connected: 'Jo yhdistetty. Käytä listan Muokkaa tunnistetietoja -toimintoa vaihtaaksesi avaimen.',
        already_connected_short: 'Jo yhdistetty.',
      },
      stripe_direct: {
        title: 'Stripe (suora)',
        description: 'Veloita jokaista ravintolaa yhden oman Stripe-tilisi kautta.',
        unavailable: 'Ei vielä saatavilla alueellasi.',
      },
      paypal: {
        direct: 'Tarjoa PayPalia omasta PayPal-yritystilistäsi.',
        braintree: 'Vastaanota kortteja, PayPalia ja Venmoa Braintree-tilisi kautta.',
      },
      other: {
        title: 'Muut palveluntarjoajat',
        search: 'Hae palveluntarjoajia',
        loading: 'Ladataan palveluntarjoajia…',
        no_match: 'Palveluntarjoajaa ”{{query}}” ei löytynyt.',
        none_available: 'Alueellasi ei ole vielä muita saatavilla olevia palveluntarjoajia.',
        load_error: 'Palveluntarjoajien listaa ei voitu ladata.',
        retry: 'Yritä uudelleen',
        pinned_match: 'Kyseinen palveluntarjoaja on kiinnitetty yllä.',
      },
      not_listed: {
        action: 'Palveluntarjoajaani ei ole listattu',
        subject: 'Maksupalveluntarjoajapyyntö: {{query}}',
      },
      use_foodamigos: {
        no_account: 'Minulla ei ole tiliä millekään näistä',
        switch: 'Vaihda FoodAmigos-maksuihin',
      },
    },
    orchestrated: {
      title: 'Yhdistä {{name}}',
      replace_title: 'Vaihda {{name}}:n tunnistetiedot',
      intro: 'Syötä {{name}}-tilisi tunnistetiedot. Tarkistamme ne {{name}}:n kanssa ennen tallentamista.',
      auth_mode: 'Miten kirjaudut tähän palveluntarjoajaan',
      checking: 'Tarkistetaan {{name}}:n kanssa…',
      paypal_direct: {
        intro:
          'Liitä sen PayPal REST -sovelluksen Client ID ja Secret, jonka kautta ravintolasi ottavat vastaan PayPal-maksuja. Tarkistamme ne PayPalin kanssa ennen tallentamista.',
        client_id: 'Client ID',
        secret: 'Secret',
        hint: 'PayPal Developer Dashboard → Apps & Credentials, Live-välilehdellä. Käytä yritystilisi REST-sovellusta.',
        hint_sandbox:
          'PayPal Developer Dashboard → Apps & Credentials, Sandbox-välilehdellä: tämä ympäristö hyväksyy vain sandbox-sovelluksia.',
      },
      braintree: {
        intro:
          'Syötä Braintree-tilisi API-avaimet. PayPal ja Venmo toimivat, kun ne on linkitetty Braintree Control Panelissa — otat ne käyttöön yhteyskohtaisesti myöhemmin.',
      },
      authorize_net: {
        intro:
          'Syötä Authorize.Net-tilisi API Login ID ja Transaction Key. Tarkistamme ne pienellä testivaltuutuksella: Authorize.Net-tapahtumalokissasi se näkyy hylättynä 1,00 $:n tapahtumana, eikä rahaa siirry. Tilin on oltava Live-tilassa, sillä testitilassa Authorize.Net hylkää kaikki todelliset maksut.',
        hint: 'Löydät molemmat Authorize.Netin Merchant Interfacesta kohdasta {{path}}.',
      },
      card_connect: {
        intro:
          'Anna live-CardConnect-tilisi (CardPointe) kauppiastunnus, käyttäjätunnus ja salasana. Tarkistamme ne 1,00 valtuutuksella, jonka mitätöimme heti: CardPointen tapahtumalokissa se näkyy hylättynä tai mitätöitynä 1,00:na, eikä rahaa siirry.',
      },
      stripe_direct: {
        intro:
          'Liitä sen Stripe-tilin salainen avain tai rajoitettu avain, jonka kautta kaikkien ravintoloiden tulee veloittaa. Määritämme puolestasi Stripen tarvitseman webhookin.',
        secret_key: 'Stripen salainen tai rajoitettu avain',
        hint: 'Stripe → Developers → API keys. Alkaa tunnuksella sk_ (salainen) tai rk_ (rajoitettu). Rajoitettu avain tarvitsee kirjoitusoikeuden (Write) kohteisiin Charges and Refunds, Customers, PaymentIntents, PaymentMethods, SetupIntents, Tokens ja Webhook Endpoints. Julkaistavaa avainta (publishable key) ei tarvita.',
        prefix_error: 'Stripen salaiset avaimet alkavat tunnuksella sk_ ja rajoitetut avaimet tunnuksella rk_.',
      },
      connected: {
        title: '{{name}} on yhdistetty.',
        description:
          'Käytämme näitä tunnistetietoja kaikille ravintoloillesi. Jokainen ravintola lisää silti omat yritystietonsa.',
      },
      errors: {
        generic: '{{name}}:n yhdistäminen ei onnistunut',
      },
    },
    stripe: {
      title: 'Yhdistä Stripe Connect',
      rotate_title: 'Vaihda Stripe Connect -avaimesi',
      rotate_intro:
        'Liitä uusi salainen avain ja julkinen avain samalta Stripe-tililtä. Ravintolasi pysyvät yhdistettyinä.',
      intro: 'Liitä Stripe-tilisi salainen avain ja julkinen avain. Molemmat löytyvät kohdasta Developers → API keys.',
      verify_and_connect: 'Vahvista ja yhdistä',
      checking: 'Tarkistetaan Stripen kanssa…',
      secret_key: {
        label: 'Salainen avain',
        hint: 'Stripe → Developers → API keys. Alkaa tunnuksella sk_.',
        prefix_error: 'Salaiset avaimet alkavat tunnuksella sk_. Tämä vaikuttaa erityyppiseltä avaimelta.',
      },
      restricted_key: {
        label: 'Rajoitettu API-avain',
        hint: 'Stripe → Developers → API keys → Create restricted key. Alkaa tunnuksella rk_. Määritä se yllä kuvatulla tavalla.',
        prefix_error: 'Rajoitetut avaimet alkavat tunnuksella rk_. Tämä vaikuttaa erityyppiseltä avaimelta.',
      },
      use_restricted_key: 'Käytä sen sijaan rajoitettua avainta',
      use_secret_key: 'Käytä sen sijaan salaista avainta',
      publishable_key: {
        label: 'Julkinen avain',
        hint: 'Samalla Stripe-sivulla. Alkaa tunnuksella pk_. Storefrontisi tarvitsevat sitä korttimaksujen hyväksymiseen.',
        prefix_error: 'Julkiset avaimet alkavat tunnuksella pk_.',
        mode_mismatch: 'Toinen avain on live-avain ja toinen testiavain. Molempien on oltava samasta Stripe-tilasta.',
      },
      name: {
        label: 'Nimeä tämä yhteys',
        hint: 'Valinnainen. Näkyy kaikkialla, missä tämä palveluntarjoaja on listattuna.',
        placeholder: 'Stripe Connect',
      },
      permissions: {
        title: 'Näin luot tämän avaimen',
        start_blank:
          'Kun Stripe kysyy, miten käytät avainta, valitse ”{{option}}”. Se alkaa niin, että kaikki oikeudet on asetettu tilaan {{none}}.',
        intro:
          'Aseta sitten kytkin päälle jokaisella näistä osiorivistä. Se asettaa kaikki kyseisen osion oikeudet, joten niitä ei tarvitse käydä läpi yksitellen.',
        rows_checked: 'Tarkistamme: {{rows}}',
        secret_key_hint: 'Jätä kaikki muut osiot tilaan {{none}}. Salainen avain ei tarvitse mitään näistä.',
        open_stripe: 'Avaa Stripe-API-avaimesi',
      },
      login_setting: {
        title: 'Poista Stripen kirjautuminen käytöstä ravintoloillesi',
        description:
          'Avaa Stripe-hallintapaneelissasi Settings → Connect → Payouts → External accounts ja poista käytöstä ”{{setting}}”. Kun se on käytössä, Stripe pakottaa jokaisen ravintolan luomaan Stripe-kirjautumisen puhelinnumerolla käyttöönoton yhteydessä ja pyytää SMS-koodia jokaisella myöhemmällä käynnillä, joten se, jolla ei ole kyseistä puhelinta, ei voi jatkaa.',
        bank_details: 'Mitään ei menetetä: ravintolat syöttävät pankkitietonsa omaan lomakkeeseemme.',
        open_stripe: 'Avaa tämä Stripe-asetus',
      },
      errors: {
        generic: 'Stripeen ei saatu yhteyttä',
      },
    },
    default_choice: {
      label: 'Käytä oletuksena ravintoloille',
      hint: 'Uudet ravintolat ja ravintolat, joilla ei vielä ole palveluntarjoajaa, linkitetään siihen automaattisesti. Jätä valitsematta, jos haluat valita palveluntarjoajan itse jokaiselle ravintolalle.',
    },
    manage: {
      payment_methods: 'Maksutavat',
      edit_credentials: 'Muokkaa tunnistetietoja',
      edit_credentials_unavailable: 'Muokkaa tunnistetietoja (tätä palveluntarjoajaa ei tällä hetkellä tarjota)',
      set_primary: 'Aseta oletukseksi uusille ravintoloille',
      clear_primary: 'Lopeta käyttö oletuksena uusille ravintoloille',
      rename: {
        action: 'Nimeä yhteys uudelleen',
        title: 'Nimeä tämä yhteys uudelleen',
        confirm: 'Tallenna',
      },
      disconnect: {
        action: 'Katkaise yhteys',
        title: 'Katkaistaanko yhteys {{name}}:iin?',
        confirm: 'Katkaise yhteys',
        warning_one: '{{count}} ravintola on linkitetty siihen ja palaa tilaan Ei määritetty.',
        warning_other: '{{count}} ravintolaa on linkitetty siihen ja palaa tilaan Ei määritetty.',
        live: {
          title_one: 'Verkkomaksut keskeytyvät {{count}} toimivalta ravintolalta',
          title_other: 'Verkkomaksut keskeytyvät {{count}} toimivalta ravintolalta',
          description:
            'Heti kun katkaiset yhteyden, heidän asiakkaansa eivät voi enää maksaa verkossa. Jokainen palaa tilaan Ei määritetty, kunnes linkität sen toiseen palveluntarjoajaan.',
          refunds: 'Tämän palveluntarjoajan kautta jo maksettuja tilauksia ei voi enää hyvittää FoodAmigosista.',
          pause_one: 'Keskeytä verkkomaksut tältä ravintolalta',
          pause_other: 'Keskeytä verkkomaksut näiltä {{count}} ravintolalta',
          confirm: 'Katkaise yhteys ja keskeytä maksut',
        },
      },
      remove: {
        action: 'Poista listalta',
        title: 'Poistetaanko {{name}}?',
        description: 'Yhteys on jo katkaistu, eikä yksikään ravintola käytä sitä. Se ei enää näy tässä listassa.',
        confirm: 'Poista',
      },
    },
    payment_methods: {
      title: '{{name}}:n maksutavat',
      description:
        'Valitse paikalliset maksutavat, joita ravintolasi tarjoavat tämän palveluntarjoajan kautta. Jokainen näkyy vain, jos ravintolan valuutta vastaa sitä.',
      save: 'Tallenna',
      publishable_key: {
        label: 'Stripen julkinen avain',
        hint: 'Stripe tarvitsee sitä maksulomakkeen näyttämiseen. Löydät sen Stripe-hallintapaneelista kohdasta Developers → API keys.',
        invalid: 'Julkinen avain alkaa tässä tunnuksella {{prefix}}.',
        clear_to_save:
          'Se kuuluu Stripen toiseen tilaan. Tyhjennä se tallentaaksesi niin, että kaikki paikalliset menetelmät ovat pois päältä.',
      },
      on_other_connection: 'jo käytössä kohteelle {{connection}}',
      other_currency: 'ei tarjolla valuutassa {{currency}}',
      delivery_only: '{{name}} (vain toimitustilaukset — vaatii asiakkaan osoitteen)',
      invite_only:
        '{{name}} (Stripe tarjoaa tätä vain kutsusta — pyydä käyttöoikeutta Stripe-hallintapaneelista ensin, muuten Stripe hylkää jokaisen maksun)',
      also_enable: {
        stripe:
          'Ota samat menetelmät käyttöön Stripe-hallintapaneelissa kohdassa Asetukset → Maksutavat, muuten Stripe hylkää ne.',
        provider: 'Sopimuksesi tämän palveluntarjoajan kanssa on katettava tässä käyttöön otettavat menetelmät.',
        braintree:
          'Linkitä PayPal ja Venmo ensin Braintree-hallintapaneelissa kohdassa Asetukset → Käsittely, muuten Braintree hylkää ne. Venmo on tarkoitettu yhdysvaltalaisille ravintoloille, jotka veloittavat dollareissa.',
        paypal_direct: 'PayPal-maksut maksetaan tälle PayPal-yritystilille. Venmoa varten yhdistä Braintree.',
      },
    },
    actions: {
      cancel: 'Peruuta',
    },
    toasts: {
      load_error: 'Yhdistettyjen palveluntarjoajien lataaminen epäonnistui',
      credentials_replaced: 'Tunnistetiedot korvattu',
      save_error: 'Tallentaminen epäonnistui',
      connected: 'Stripe Connect on yhdistetty',
      renamed: 'Yhteys nimetty uudelleen',
      primary_set: 'Oletuspalveluntarjoaja päivitetty',
      primary_cleared:
        'Oletuspalveluntarjoaja poistettu. Uusia ravintoloita ei linkitetä palveluntarjoajaan ennen kuin valitset sellaisen.',
      disconnected: 'Palveluntarjoajan yhteys katkaistu',
      removed: 'Palveluntarjoaja poistettu',
      payment_methods_saved: 'Maksutavat tallennettu',
    },
  },
  restaurants: {
    title: 'Ravintolat',
    description: 'Missä kukin ravintola on verkkomaksujen käyttöönotossa.',
    search: 'Hae ravintoloita',
    filters: {
      all: 'Kaikki ({{count}})',
      needs_attention: 'Vaatii huomiota ({{count}})',
    },
    empty: 'Ei vielä ravintoloita.',
    empty_attention: 'Mikään ei vaadi huomiotasi.',
    columns: {
      restaurant: 'Ravintola',
      provider: 'Palveluntarjoaja',
      status: 'Tila',
      action: 'Toiminto',
    },
    no_provider: '—',
    foodamigos_payments: 'FoodAmigos-maksut',
    groups: {
      not_set_up: 'Ei määritetty',
      business_details_missing: 'Yritystiedot puuttuvat',
      hosted_not_finished: '{{provider}}-lomaketta ei saatu valmiiksi',
      hosted_not_finished_generic: 'Palveluntarjoajan lomaketta ei saatu valmiiksi',
      waiting_for_provider: 'Odottaa palveluntarjoajaa',
      action_needed: 'Vaatii toimenpiteitä',
      payments_live: 'Maksut käytössä',
      online_payments_off: 'Verkkomaksut pois päältä',
      waiting_for_partner: 'Odottaa sinua',
    },
    link_expired: 'Linkki vanhentunut',
    actions: {
      set_up: 'Määritä',
      change: 'Muuta',
      unlink: 'Poista linkitys',
      remind: 'Muistuta omistajaa',
      reminded: 'Muistutettu · uudelleen {{time}}',
      start_over: 'Aloita Stripe-asetukset alusta',
    },
    assign: {
      title: 'Mitä palveluntarjoajaa {{name}} käyttää?',
      label: 'Palveluntarjoaja',
      confirm: 'Tallenna',
      cancel: 'Peruuta',
      primary: 'Oletus',
      none: 'Yhdistä palveluntarjoaja ensin.',
    },
    unlink: {
      title: 'Poistetaanko linkitys {{name}} ja {{provider}} välillä?',
      title_generic: 'Poistetaanko {{name}} linkitys sen palveluntarjoajasta?',
      description:
        'Ravintola palaa tilaan Ei määritetty, jotta voit valita sille oikean palveluntarjoajan. Palveluntarjoaja pysyy yhdistettynä muille ravintoloillesi.',
      confirm: 'Poista linkitys',
    },
    pause: {
      title: 'Verkkomaksut keskeytyvät ravintolalle {{name}}',
      description:
        'Sen asiakkaat eivät voi enää maksaa verkossa, ennen kuin ravintola on taas määritetty ja vahvistettu palveluntarjoajan kanssa.',
      refunds: 'Nykyisen palveluntarjoajan kautta jo maksettuja tilauksia ei voi enää hyvittää FoodAmigosin kautta.',
      confirm: 'Keskeytä verkkomaksut tältä ravintolalta',
    },
    start_over: {
      title: 'Aloitetaanko ravintolan {{name}} Stripe-asetukset alusta?',
      points: {
        not_used: 'Sen nykyistä Stripe-tiliä ({{account}}) ei enää käytetä tälle ravintolalle.',
        kept: 'Tiliä ei poisteta: se pysyy Stripe-tililläsi, jossa voit hylätä sen.',
        fresh: 'Seuraava ”Jatka” aloittaa Stripen ensimmäiseltä sivulta, ja voit käyttää eri sähköpostiosoitetta.',
        paused: 'Jos ravintola vastaanottaa verkkomaksuja, ne keskeytyvät, kunnes uusi asetus on valmis.',
      },
      confirm: 'Aloita alusta',
      blocked: {
        received_payments:
          'Tämän ravintolan Stripe-tili on vastaanottanut maksuja, joten sen asetuksia ei voi aloittaa alusta. Ota yhteyttä tukeen muutosta varten.',
        partner_action_needed: 'Korjaa ensin Stripe Connectissa näkyvä ongelma.',
      },
    },
    toasts: {
      load_error: 'Ravintoloidesi lataaminen epäonnistui',
      assigned: 'Palveluntarjoaja tallennettu',
      assign_error: 'Palveluntarjoajan tallentaminen epäonnistui',
      unlinked: 'Ravintolan linkitys poistettu',
      unlink_error: 'Ravintolan linkityksen poistaminen epäonnistui',
      reminded: 'Muistutus lähetetty omistajalle',
      remind_error: 'Muistutuksen lähettäminen epäonnistui',
      cooling_down: 'Omistajaa on jo muistutettu tänään',
      started_over: 'Stripe-asetukset aloitettu alusta',
      start_over_error: 'Stripe-asetusten aloittaminen alusta epäonnistui',
    },
  },
  footer: {
    text: 'FoodAmigos-palvelumaksusi laskutetaan sinulta riippumatta siitä, mitä palveluntarjoajaa ravintola käyttää.',
    link: 'Katso Laskutus',
  },
};
